import { ComboBoxOption } from '../components/datafields/ComboBoxField';

export const BUSINESS_FIELD_OPTIONS: ComboBoxOption[] = [
  // Technology & Software
  {
    value: 'Software Development',
    label: 'Software Development',
    group: 'Technology & Software',
  },
  {
    value: 'IT Services & Consulting',
    label: 'IT Services & Consulting',
    group: 'Technology & Software',
  },
  {
    value: 'SaaS / Cloud Services',
    label: 'SaaS / Cloud Services',
    group: 'Technology & Software',
  },
  {
    value: 'Cybersecurity',
    label: 'Cybersecurity',
    group: 'Technology & Software',
  },
  {
    value: 'Artificial Intelligence / Data Science',
    label: 'Artificial Intelligence / Data Science',
    group: 'Technology & Software',
  },
  {
    value: 'Web / Mobile App Development',
    label: 'Web / Mobile App Development',
    group: 'Technology & Software',
  },
  {
    value: 'Gaming & eSports',
    label: 'Gaming & eSports',
    group: 'Technology & Software',
  },

  // E-Commerce & Retail
  {
    value: 'E-Commerce (Online Store)',
    label: 'E-Commerce (Online Store)',
    group: 'E-Commerce & Retail',
  },
  {
    value: 'Retail (Physical Goods)',
    label: 'Retail (Physical Goods)',
    group: 'E-Commerce & Retail',
  },
  {
    value: 'Wholesale & Distribution',
    label: 'Wholesale & Distribution',
    group: 'E-Commerce & Retail',
  },
  {
    value: 'Dropshipping',
    label: 'Dropshipping',
    group: 'E-Commerce & Retail',
  },
  {
    value: 'Consumer Goods',
    label: 'Consumer Goods',
    group: 'E-Commerce & Retail',
  },

  // Professional Services
  {
    value: 'Consulting (Business / Management / Strategy)',
    label: 'Consulting (Business / Management / Strategy)',
    group: 'Professional Services',
  },
  {
    value: 'Legal Services',
    label: 'Legal Services',
    group: 'Professional Services',
  },
  {
    value: 'Accounting & Bookkeeping',
    label: 'Accounting & Bookkeeping',
    group: 'Professional Services',
  },
  {
    value: 'Marketing & Advertising',
    label: 'Marketing & Advertising',
    group: 'Professional Services',
  },
  {
    value: 'Design Services (Graphic / Product / UI/UX)',
    label: 'Design Services (Graphic / Product / UI/UX)',
    group: 'Professional Services',
  },
  {
    value: 'HR & Recruitment',
    label: 'HR & Recruitment',
    group: 'Professional Services',
  },
  {
    value: 'Coaching & Training',
    label: 'Coaching & Training',
    group: 'Professional Services',
  },

  // Finance & Insurance
  {
    value: 'Banking / Financial Services',
    label: 'Banking / Financial Services',
    group: 'Finance & Insurance',
  },
  {
    value: 'Investment / Asset Management',
    label: 'Investment / Asset Management',
    group: 'Finance & Insurance',
  },
  { value: 'Insurance', label: 'Insurance', group: 'Finance & Insurance' },
  { value: 'FinTech', label: 'FinTech', group: 'Finance & Insurance' },

  // Manufacturing & Industrial
  {
    value: 'Manufacturing (General)',
    label: 'Manufacturing (General)',
    group: 'Manufacturing & Industrial',
  },
  {
    value: 'Automotive',
    label: 'Automotive',
    group: 'Manufacturing & Industrial',
  },
  {
    value: 'Electronics & Hardware Production',
    label: 'Electronics & Hardware Production',
    group: 'Manufacturing & Industrial',
  },
  {
    value: 'Machinery & Equipment',
    label: 'Machinery & Equipment',
    group: 'Manufacturing & Industrial',
  },
  {
    value: 'Chemicals / Materials',
    label: 'Chemicals / Materials',
    group: 'Manufacturing & Industrial',
  },

  // Construction & Real Estate
  {
    value: 'Construction',
    label: 'Construction',
    group: 'Construction & Real Estate',
  },
  {
    value: 'Architecture & Engineering',
    label: 'Architecture & Engineering',
    group: 'Construction & Real Estate',
  },
  {
    value: 'Real Estate Development',
    label: 'Real Estate Development',
    group: 'Construction & Real Estate',
  },
  {
    value: 'Property Management / Rental',
    label: 'Property Management / Rental',
    group: 'Construction & Real Estate',
  },

  // Healthcare & Life Sciences
  {
    value: 'Healthcare Services',
    label: 'Healthcare Services',
    group: 'Healthcare & Life Sciences',
  },
  {
    value: 'Medical Devices',
    label: 'Medical Devices',
    group: 'Healthcare & Life Sciences',
  },
  {
    value: 'Pharmaceuticals',
    label: 'Pharmaceuticals',
    group: 'Healthcare & Life Sciences',
  },
  {
    value: 'Biotechnology',
    label: 'Biotechnology',
    group: 'Healthcare & Life Sciences',
  },
  {
    value: 'Wellness & Fitness',
    label: 'Wellness & Fitness',
    group: 'Healthcare & Life Sciences',
  },

  // Food & Hospitality
  {
    value: 'Restaurants / Food Services',
    label: 'Restaurants / Food Services',
    group: 'Food & Hospitality',
  },
  { value: 'Catering', label: 'Catering', group: 'Food & Hospitality' },
  {
    value: 'Hotels & Accommodation',
    label: 'Hotels & Accommodation',
    group: 'Food & Hospitality',
  },
  {
    value: 'Travel & Tourism',
    label: 'Travel & Tourism',
    group: 'Food & Hospitality',
  },

  // Media, Arts & Entertainment
  {
    value: 'Film / Video Production',
    label: 'Film / Video Production',
    group: 'Media, Arts & Entertainment',
  },
  {
    value: 'Music / Performing Arts',
    label: 'Music / Performing Arts',
    group: 'Media, Arts & Entertainment',
  },
  {
    value: 'Publishing & Journalism',
    label: 'Publishing & Journalism',
    group: 'Media, Arts & Entertainment',
  },
  {
    value: 'Advertising / Creative Agency',
    label: 'Advertising / Creative Agency',
    group: 'Media, Arts & Entertainment',
  },
  {
    value: 'Gamers / Content Creators',
    label: 'Gamers / Content Creators',
    group: 'Media, Arts & Entertainment',
  },

  // Education & Non-Profit
  {
    value: 'Schools / Education Providers',
    label: 'Schools / Education Providers',
    group: 'Education & Non-Profit',
  },
  {
    value: 'Online Courses / eLearning',
    label: 'Online Courses / eLearning',
    group: 'Education & Non-Profit',
  },
  {
    value: 'Non-Profit / Charity',
    label: 'Non-Profit / Charity',
    group: 'Education & Non-Profit',
  },
  {
    value: 'Research Institutions',
    label: 'Research Institutions',
    group: 'Education & Non-Profit',
  },

  // Logistics & Transportation
  {
    value: 'Shipping & Logistics',
    label: 'Shipping & Logistics',
    group: 'Logistics & Transportation',
  },
  {
    value: 'Warehousing',
    label: 'Warehousing',
    group: 'Logistics & Transportation',
  },
  {
    value: 'Transportation (Ground / Air / Maritime)',
    label: 'Transportation (Ground / Air / Maritime)',
    group: 'Logistics & Transportation',
  },
  {
    value: 'Delivery Services',
    label: 'Delivery Services',
    group: 'Logistics & Transportation',
  },

  // Agriculture & Environment
  {
    value: 'Agriculture / Farming',
    label: 'Agriculture / Farming',
    group: 'Agriculture & Environment',
  },
  {
    value: 'Food Production',
    label: 'Food Production',
    group: 'Agriculture & Environment',
  },
  { value: 'Forestry', label: 'Forestry', group: 'Agriculture & Environment' },
  {
    value: 'Environmental Services',
    label: 'Environmental Services',
    group: 'Agriculture & Environment',
  },
  {
    value: 'Renewable Energy',
    label: 'Renewable Energy',
    group: 'Agriculture & Environment',
  },

  // Energy & Utilities
  { value: 'Oil & Gas', label: 'Oil & Gas', group: 'Energy & Utilities' },
  {
    value: 'Power Generation',
    label: 'Power Generation',
    group: 'Energy & Utilities',
  },
  {
    value: 'Water / Utilities',
    label: 'Water / Utilities',
    group: 'Energy & Utilities',
  },
  {
    value: 'Solar / Wind / Renewable Energy',
    label: 'Solar / Wind / Renewable Energy',
    group: 'Energy & Utilities',
  },

  // Beauty, Fashion & Lifestyle
  {
    value: 'Fashion & Apparel',
    label: 'Fashion & Apparel',
    group: 'Beauty, Fashion & Lifestyle',
  },
  {
    value: 'Cosmetics / Beauty Products',
    label: 'Cosmetics / Beauty Products',
    group: 'Beauty, Fashion & Lifestyle',
  },
  {
    value: 'Health & Personal Care',
    label: 'Health & Personal Care',
    group: 'Beauty, Fashion & Lifestyle',
  },
  {
    value: 'Influencer / Creator Business',
    label: 'Influencer / Creator Business',
    group: 'Beauty, Fashion & Lifestyle',
  },
];
